import React from "react";

import { BackButton } from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import ApprovalProcess from "./CreateApproval";

const modules = [
    "purchase_request",
    "purchase_order",
    "payment_request",
    "invoive_incomming",
    "invoive_outgoing",
    "grn",
    "delivery_note",
    "request",
    "return",
  
];

const NewApprovalIndex = () => {
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Settings" },
            { name: "Approval Status" },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
        {modules.map((mod) => (
          <div key={mod} className="p-3">
            <ApprovalProcess moduleName={mod} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewApprovalIndex;
